import { CareType } from '@models/common/care-type.model';
import { Community } from '@models/communities/community.model';
import { InjectionToken } from '@angular/core';
import { Investor } from '@models/common/investor.model';
import { ModelService } from '@services/common/model.service';
import { Region } from '@models/calendar/Region.model';
import { Survey } from '@models/feed-back/survey.model';
import { SurveySchedule } from '@models/feed-back/survey-schedule.model';

export const FeedbackPlatformCommunities = new InjectionToken<
  ModelService<Community[]>
>('FeedbackPlatformCommunities');
export const FeedbackPlatformCareTypes = new InjectionToken<
  ModelService<CareType[]>
>('FeedbackPlatformCareTypes');
export const FeedbackPlatformRegions = new InjectionToken<
  ModelService<Region[]>
>('FeedbackPlatformRegions');
export const FeedbackPlatformInvestors = new InjectionToken<
  ModelService<Investor[]>
>('FeedbackPlatformInvestors');
export const FeedbackPlatformSurveys = new InjectionToken<
  ModelService<SurveySchedule[]>
>('FeedbackPlatformSurveys');
export const FeedbackPlatformFilteredSurveys = new InjectionToken<
  ModelService<SurveySchedule[]>
>('FeedbackPlatformFilteredSurveys');
// #endregion
